import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Header from "../components/Header";
import Heroes from "../components/Heroes";
import { Box, FormControl, InputLabel, MenuItem, Select } from '@mui/material';


function HeroesPage() {
  const [heroes, setHeroes] = useState([]);
  const [roles, setRoles] = useState([]);
  const [selectedRole, setSelectedRole] = useState('');

  useEffect(() => {
    axios.get('https://overfast-api.tekrop.fr/heroes')
      .then((res) => {
        setHeroes(res.data);
        const uniqueRoles = Array.from(new Set(res.data.map(hero => hero.role)));
        setRoles(uniqueRoles);
      })
      .catch(error => console.error('Error fetching heroes:', error));
  }, []);

  const handleRoleChange = (event) => {
    setSelectedRole(event.target.value);
  };

  const filteredHeroes = selectedRole
    ? heroes.filter(hero => hero.role === selectedRole)
    : heroes;

  return (
    <div>
      <Header />
      <div style={{ margin: '16px' }}>
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <FormControl sx={{ m: 1, minWidth: 240 }} size="small">

            <Select
              sx={{
                backgroundColor: 'white',
                color: 'black',
                fontFamily: 'Oswald, sans-serif',
                letterSpacing: '1.1px',
                fontSize: '18px',
                textTransform: 'uppercase',

              }}
              labelId="role-select-label"
              id="role-select"
              value={selectedRole}
              onChange={handleRoleChange}

              displayEmpty
            >
              <MenuItem sx={{
                color: 'black',
                fontFamily: 'Oswald, sans-serif',
                letterSpacing: '1.1px',
                fontSize: '18px',
                textTransform: 'uppercase',
                "&:hover": {
                  backgroundColor: "#43444a", color: "white"
                }
              }} value="">
                Tous
              </MenuItem>
              {roles.map(role => (
                <MenuItem sx={{
                  color: 'black',
                  fontFamily: 'Oswald, sans-serif',
                  letterSpacing: '1.1px',
                  fontSize: '18px',
                  textTransform: 'uppercase',

                  "&:hover": {
                    backgroundColor: "#43444a", color: "white"
                  }
                }} key={role} value={role}>{role}</MenuItem>
              ))}
            </Select>
          </FormControl>
        </div>
        <Box sx={{ marginTop: 2, display: 'flex', gap: 2, flexWrap: 'wrap', justifyContent: 'center' }}>
          {filteredHeroes.map(hero => (
            <Heroes key={hero.key} heroes={hero} />
          ))}
        </Box>
      </div>
    </div>

  );
}

export default HeroesPage;
